import _ from 'lodash';

const accountSales = [
  { id: 'total', label: '판매관리비 계' },
  { id: '급여', label: '급여' },
  { id: '퇴직급여', label: '퇴직급여' },
  { id: '접대비', label: '접대비' },
  { id: '복리후생비', label: '복리후생비' },
  { id: '여비교통비', label: '여비교통비' },
  { id: '차량유지비', label: '차량유지비' },
  { id: '소모품비', label: '소모품비' },
  { id: '지급수수료', label: '지급수수료' },
  { id: '보험료', label: '보험료' },
  { id: '사대보험', label: '사대보험' },
  { id: '건물관리비', label: '건물관리비' },
  { id: '경상연구개발비', label: '경상연구개발비' },
  { id: '세금과공과', label: '세금과공과' },
  { id: '수선비', label: '수선비' },
  { id: '운반비', label: '운반비' },
  { id: '도서인쇄비', label: '도서인쇄비' },
  { id: '광고선전비', label: '광고선전비' },
  { id: '교육훈련비', label: '교육훈련비' },
  { id: '비품', label: '비품' },
  { id: '지급임차료', label: '지급임차료' },
  { id: '연구비', label: '연구비' },
  { id: '외주용역비', label: '외주용역비' },
  { id: '협회비', label: '협회비' },
  { id: '운반비이자수익', label: '이자수익' },
  { id: '잡이익', label: '잡이익' },
  { id: '외환차익', label: '외환차익' },
  { id: '국고보조금', label: '국고보조금' },
  { id: '판매장려금', label: '판매장려금' },
  { id: '기부금', label: '기부금' },
  { id: '이자비용', label: '이자비용' },
  { id: '잡손실', label: '잡손실' },
  { id: '외환차손', label: '외환차손' },
  { id: '법인세등', label: '법인세등' },
];

export const salesmanColumns = [
  { id: 'annual_budget', label: '연 예산' },
  { id: 'total', label: '합계' },
  { id: 'pou', label: '비율' },
  { id: 'direct_cost', label: '직접비' },
  { id: 'total_cost', label: '전체공통비' },
  { id: 'mphq_cost', label: '경영기획본부공통비' },
  { id: 'hq_cost', label: '본부별공통비' },
  { id: 'team_cost', label: '팀별공통비' },
  { id: 'head_cost', label: '본사공통비' },
];

// pou => percentage of usage : 사용 비율
export const makeSalesMngCostHeader = () => {
  const array = [
    { id: 'annual_budget', label: '연 예산' },
    { id: 'total', label: '합계' },
    { id: 'pou', label: '사용 비율' },
  ];
  for (let index = 0; index < 12; index++) {

    let displayIdx = index + 1;

    let object = { id: `${displayIdx}`, label: displayIdx + '월' };
    array.push(object);
  }
  return array;
};

export const makeSaleMngCostData = () => {
  const array = [];
  _.forEach(accountSales, (item) => {
    const object = { id: item.id, label: item.label, data: [] };

    _.forEach(makeSalesMngCostHeader(), (values) => {
      const accountObject = {
        id: values.id,
        value:
          values.id !== 'pou'
            ? `${Math.floor(Math.random() * 1000000000)}`
            : `${Math.floor(Math.random() * 100)}`,
      };
      object.data.push(accountObject);
    });
    array.push(object);
  });
  return array;
};

export const makeSalemanMngCostData = () => {
  const array = [];
  _.forEach(accountSales, (item) => {
    const object = { id: item.id, label: item.label, data: [] };

    _.forEach(salesmanColumns, (values) => {
      const accountObject = {
        id: values.id,
        value:
          values.id !== 'pou'
            ? `${Math.floor(Math.random() * 1000000000)}`
            : `${Math.floor(Math.random() * 100)}`,
      };
      object.data.push(accountObject);
    });
    array.push(object);
  });
  return array;
};
